// custom case insensitive :contains function
$.expr[':'].containsIgnoreCase = function(n, i, m){
    return jQuery(n).text().toUpperCase().indexOf(m[3].toUpperCase()) >= 0;
};

(function($) {
  $.widget('ui.axFilter', {
    options: {
      axTable: false,       // axTable element
      isClientSide: false,  // use client side filtering
      isTreeView: false,    // when True - will also show parent element
      template: false       // custom template
    },

    _create: function() {
      var self = this,
          settings = this.options;

      if (typeof settings.axTable != 'object') {
        console.log('axFilter: axTable missing. Interrupted'); return;
      }
      // wait until axTable created
      $(settings.axTable).on('axtablecreatecomplete', function() {
        if (settings.template && !window.cachedAxTemplates[settings.template]) {
          // Load template into cache
          $.ajax({
            url: "/" + settings.template,
            success: function (template) {
              // Save in cache for next time.
              window.cachedAxTemplates[settings.template] = template;
              self._initialize();
            },
            async: false
          });
        } else {
          self._initialize();
        }
      });
    },

    _initialize: function() {
      var self = this,
          settings = this.options,
          axTable = $(settings.axTable).data('ax-axTable'),
          savedFilter = axTable.search(),
          provider = (settings.isClientSide != true) ? axTable : self;    // search provider (axFilter | axTable)

      if (settings.template) {
        self._addFilterPane(settings.template);
      }

      if (savedFilter) {
        // restore previous filter
        $.each(savedFilter, function(key, value) {
          var element = $(self.element).find('[data-field='+ key +']');
          if (element.length) {
            element.val(value);
            // needed to manually call change event to update custom comboboxes
            if (element.is('select')) {
              if (element.siblings(":data('ui-combobox')").length == 0) {
                // not a combobox
                element.trigger('change');
              } else {
                // There should be only one
                element.siblings(":data('ui-combobox')").each(function() {
                  $(this).data('ui-combobox').refreshSelected();
                });
              }
            }
          } else {
            var element = $(self.element).find('#filter_'+ key);
            if (element.length && element.is('.s2.filter-field') && value != '') {
              element.val(value);
            } else {
              var element = $(self.element).find('#'+ key);
              if (element.length && value != '') {
                element.data('saved', value);
              }
            }
          }
        });

        //The filter could be empty, check whether link should be hidden or shown
        var fields = self.submit();
        self.hideShowReset(fields);
        // postpone axTable fetchdata
        if (!axTable.options.fetchOnInit) {
          axTable.reset();
        }
      } else {
        // apply default filter values
        axTable.search(self.submit());
      }

      // bind axtable reset filter
      $(settings.axTable).on('axtableresetfilter', self, self.reset);

      // bind the checkbox filter submissions after the search filter is restored
      $(self.element).find('[type=checkbox],[type=radio]').on('click', function(event){
        var fields = self.submit();
        self.hideShowReset(fields);
        provider.search(fields);
      });

      // bind axtable reset filter
      $(self.options.axTable).on('axtableresetfilter', self, self.reset);

      // bind search filter onKeyUp event
      $(self.element).find('[type=text]').not(":data('ui-combobox')").each(function() {
        $(this).on('keyup', function(event){
          var fields = self.submit();
          self.hideShowReset(fields);
          provider.search(fields);
        });
      });

      // bind search filter select change event
      $(self.element).find('select').not(function(index, elem){
        return $(elem).siblings(":data('ui-combobox')").length > 0;
      }).each(function() {
        $(this).on('change', function(event){
          var fields = self.submit();
          self.hideShowReset(fields);
          axTable.search(fields);
        });
      });

      $(self.element).find(":data('ui-combobox')").each(function() {
        $(this).combobox({change: function(event){
          var fields = self.submit();
            self.hideShowReset(fields);
            axTable.search(fields);
          }
        });
      });

      $(self.element).find('.hasDatepicker').each(function() {
        $(this).on('change', function(event){
          var fields = self.submit();
          self.hideShowReset(fields);
          axTable.search(fields);
        });
      });

      $(self.element).on('apply.filter', function() {
        var fields = self.submit();
        provider.search(fields);
      });

      self._attach_reset_handler();
    },

    _addFilterPane: function(template, data) {
      $(this.options.axTable).prepend(Handlebars.compile(window.cachedAxTemplates[template])(data));
    },

    _attach_reset_handler: function() {
      var self = this;

      $(self.element).find('.filter-reset').on('click', function() {
        $(this).find('a').hide();
        $(self.options.axTable).trigger('axtableresetfilter');
      });

      return false;
    },

    hideShowReset: function(fields) {
      var self = this, isEmpty = true;
      $.each(fields, function(key, value) {
        if (! $.isEmptyObject(value)) {
          isEmpty = false;
          $(self.element).find('.filter-reset a').show();
          return false;
        }
      });

      if (isEmpty){
        $(self.element).find('.filter-reset a').hide();
      }

      return false;
    },

    search: function(fields) {
      var self = this,
          settings = this.options,
          axTable = self.options.axTable;

      var rows = $(axTable).find('.trow:gt(0)');

      $(rows).removeClass('js-filtered').hide();

      $.each(fields, function(key, value) {
        if ($.isEmptyObject(value)) { return; }

        // merge separate results by OR
        if (Array.isArray(value)) {
          var tmp = [];
          $.each(value, function(k, p){
            tmp = $.merge(tmp, rows.filter(function(n, i){
              return $(i).find('.'+ key +':containsIgnoreCase('+ p +')').length;
            }));
          });
          rows = tmp;
          return;
        }

        rows = rows.filter(function(n, i){
          return $(i).find('.'+ key +':containsIgnoreCase('+ value +')').length;
        });
      });

      if (settings.isTreeView) {
        $.each(rows, function(i, row) {
          var $row = $(row);
          if ($row.is('[data-rel_parent]')) {
            $(axTable).find('[data-parent='+$(this).data('rel_parent')+']').show();
          }
        });
      }

      $(rows).addClass('js-filtered').show();

      var $axtable_view = $(axTable).find('.axtableview .mCustomScrollbar');
      if ($axtable_view) {
        $axtable_view.mCustomScrollbar("update");
      }
    },

    // apply server side filter
    submit: function() {
      var fields = {};  // collection of filter fields

      $(this.element).find('input:not(.ui-widget),select').each(function(){
        var field_key = this.name;

        if (field_key == '') {
          // if field name is empty - skip to next
          return;
        }

        // use data-field if it's set
        if ($(this).data('field')) {
          field_key = $(this).data('field');
        }

        // check whether checkbox/radio is checked
        if ($(this).is('[type=checkbox],[type=radiobutton]') && $(this).is(':not(:checked)')) {
          // even if checkbox/radio is not checked we should set field group (make it array)
          if (!Array.isArray(fields[field_key])) {
            if (typeof fields[field_key] != 'undefined') {
              fields[field_key] = [fields[field_key]];
            } else {
              fields[field_key] = [];
            }
          }
          return;
        }

        var val;
        if ($(this).data('select2')) {
          val = $(this).select2('val');
        } else {
          val = $(this).val() || '';
        }

        // check whether we need to set single value or use array
        if (typeof fields[field_key] != 'undefined') {
          if (!Array.isArray(fields[field_key])) {
            fields[field_key] = [fields[field_key]];
          }
          fields[field_key].push(val);
        } else {
          fields[field_key] = val;
        }
      });

      return fields;
    },

    reset: function(e) {
      var axFilter = e.data;

      $(axFilter.element).find('input:text:not(.js-no-reset), select:not(.js-no-reset), textarea').val('');

      // Set first value in dropdown as default on form clear in case if dropdown doesn't have value "-- None --".
      Array.from($(axFilter.element).find('select:not(.js-no-reset)')).forEach((el) => {
        if (el.options[0].value != 0) {
          el.parentElement.children[0].value = el.options[0].value;
          el.parentElement.children[1].value = el.options[0].text;
        }
      });

      $(axFilter.element).find('.s2.filter-field:not(.js-no-reset)').select2('val', null, true);
      $(axFilter.element).find('.ad_hoc').hide();
      $(axFilter.element).find('input:radio, input:checkbox')
          .prop('checked', false).prop('selected', false);

      $(axFilter.element).trigger('axfilter.onafterreset');

      $(this).axTable('search', axFilter.submit());
    }

  });

  $.extend($.ui.axFilter, {
    version: "1.0.0"
  });
})(jQuery);
